import * as partials from "../partials/types";

export const CHARITIES_LIST = partials.createRequestTypes("CHARITIES_LIST");
export const LOAD_CHARITIES_LIST_PAGE = "LOAD_CHARITIES_LIST_PAGE";

export * from "../partials/types";
